import i18n from '@/i18n';
import '@/styles/document-root.css';
import '@dabble/quillui/global';
import '@dabble/quillui/styles';
import '@fontsource-variable/dm-sans';
import '@fontsource-variable/inter';
import '@fontsource/pt-serif';
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import posthog from 'posthog-js';
import { createApp } from 'vue';
import {
  POSTHOG_ENVIRONMENT,
  POSTHOG_HOST,
  POSTHOG_TOKEN,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
} from './data/env';
import App from './App.vue';
import router from './router';
import { useAccountsStore } from './stores/accounts';

const app = createApp(App);

// Skip Sentry on local-dev so developer-machine errors don't reach Sentry; test/prod still captured.
if (typeof window !== 'undefined' && SENTRY_DSN && SENTRY_ENVIRONMENT !== 'local') {
  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

posthog.init(POSTHOG_TOKEN, {
  api_host: POSTHOG_HOST,
  defaults: '2026-01-30',
});
posthog.register({ environment: POSTHOG_ENVIRONMENT });

// Sentry.init({ app }) attaches its own Vue errorHandler; setting one here
// replaces it, so explicitly forward to both SDKs.
app.config.errorHandler = (err) => {
  if (err instanceof Error) {
    Sentry.captureException(err);
    posthog.captureException(err);
  }
};

const pinia = createPinia();
app.use(pinia);
app.use(i18n);

// Kick off auth resolution without blocking app mount. The router guard
// awaits the same idempotent promise via accountsStore.init(), and
// App.vue shows a <Loader/> until userDataReady flips true.
useAccountsStore().init();

app.use(router);

app.mount('#app');
